var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delivery-stage-type"},[_c('div',[_c('delivery-stage-type-badge',{attrs:{"value":_vm.deliveryStage}})],1),(_vm.deliveryType)?_c('div',[_vm._v(" --- "),_c('br'),_c('delivery-stage-type-badge',{attrs:{"value":_vm.deliveryType}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }